import { Map as map } from 'immutable';
import update from "react-addons-update";
const C = require("../constants");

function DynamicTableDataReducer(state = map(), action) {
    let results = null;
    switch (action.type) {
        case C.DYNAMIC_TABLE_LIST:
            return action.data;
        case C.DYNAMIC_TABLE_LIST_ADD_OR_UPDATE:
            results = state.data.results.slice();
            if (results.some(res => res.id === action.data.id)){
                results = results.map(data => {
                    data = action.data.id === data.id ? action.data:data;
                    return data
                });
                return update(state, {
                    data:{
                        results: {$set: results}
                    }
                });
            }else{
                results.unshift(action.data);
                return update(state, {
                    data:{
                        results: {$set: results}
                    }
                });
            }
        case C.DYNAMIC_TABLE_LIST_DELETE:
            results = state.data.results.slice();
            results = results.filter(data => {
                return data.id !== action.data;
            });
            return update(state, {
                data:{
                    results: {$set: results}
                }
            });
        default:
            return state;
    }
}

export default DynamicTableDataReducer;


// WEBPACK FOOTER //
// ./src/reducers/DynamicTableDataReducer.js